import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { 
  APPLICATION_MODE_NEW, 
  APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
  ROUTE_PATH 
} from "../../app/constants";
import {
  Header,
  Paragraph,
  Button,
  ErrorMark,
} from "../../components/RegularComponents";
import CheckboxForm from "../../components/CheckBoxForm";
import TopNavigationBar from "../TopNavigationBar";
import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";
import { ERROR_STRING } from "../../app/errors";
import { fullName } from "../../app/utils";
import { applicationTypeFromLicenceSubType } from '../../redux/slice/applicationsUtils';

const MORTGAGE_APPLICATION_PROPERTY = "lenderConfirmation";

export const LenderConfirmation = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();
  const [confirmCheck1, setConfirmCheck1] = useState(false);
  const [confirmCheck2, setConfirmCheck2] = useState(false);

  const [showValidationError, setShowValidationError] = useState(false);

  const { licencingSubType } = useSelector((state) => ({
    licencingSubType : state.primaryAgencyApplication.application?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  }));

  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
  const isLender = applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE;

  const businessContact = useSelector(
    state => state.primaryAgencyApplication.application?.businessLicenceData?.mainBusinessContact ?? {}
  )

  const handleNext = () => {
    if (
      !confirmCheck1 ||
      !confirmCheck2 
    ) {
      setShowValidationError(true);
      return;
    }

    setShowValidationError(false);

    // Set MORTGAGE PROP value
    dispatch(
      setMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: true,
      })
    );

    // On to the next item
    const nextRouteApp = (applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) ? 
                                ROUTE_PATH.MA_APP : 
                                ROUTE_PATH.ML_APP
    dispatch(
      push(
        `${nextRouteApp}${ROUTE_PATH.ML_APPLICATION_REVIEW}`
      )
    );
  };

  const handleModalClose = () => {
    // Set MORTGAGE PROP value
    dispatch(
      setMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value:
          confirmCheck1 &&
          confirmCheck2,
      })
    );

    onEditSave();
  };

  const text1 = isLender ? 
      `I, ${fullName(businessContact)} confirm that I am engaged with the activities with the mortgage lender to the extent I am capable of carrying out my duties and responsibilites as Compliance Officer under the Mortgage Regulation Act and its regulations.` 
    : `I, ${fullName(businessContact)} confirm that I am engaged with the activities with the mortgage administrator to the extent I am capable of carrying out my duties and responsibilites as Compliance Officer under the Mortgage Regulation Act and its regulations.`

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar 
              {...props} 
              applicationType={applicationType} 
              applicationMode={APPLICATION_MODE_NEW} 
            />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "20px" }}
                  id="broker-confirmation-header"
                  header="Confirmation"
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox"
              checked={confirmCheck1}
              value={confirmCheck1}
              labelStyle={{ fontWeight: "normal !important" }}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck1(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px", marginTop: "0px" }}
              id="broker-confirmation-header"
              text={[text1]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox"
              checked={confirmCheck2}
              value={confirmCheck2}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck2(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px", marginTop: "0px" }}
              id="broker-confirmation-header"
              text={[
                `I, ${fullName(businessContact)} confirm that I have read and understand the Mortgage Regulation Act and its regulations and I agree to carry out my duties and responsibilities under the Act and its regulations.`,
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div
            className={"col-lg-4" + (showValidationError ? " has-error" : "")}
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={!isModal ? handleNext : handleModalClose}
            />
            {showValidationError && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CONFIRM_MORTGAGE_EDUCATION_REQUIREMENT}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
